var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-18848 -2522)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37822",
    "data-name": "Ellipse 37822",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(18848 2522)",
    fill: "#e3f5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633214",
    "data-name": "Group 633214",
    transform: "translate(18859.65 2533.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858300",
    "data-name": "Path 858300",
    d: "M4.368,20.707,3.061,26.336A1.413,1.413,0,0,0,4.434,28.05a1.4,1.4,0,0,0,.293,0l5.66-1.3L21.256,15.921,15.194,9.87Z",
    transform: "translate(-1.471 -4.791)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858301",
    "data-name": "Path 858301",
    d: "M37.26,6.885,33.215,2.84a1.426,1.426,0,0,0-2.007,0L28.96,5.089l6.056,6.056L37.27,8.9a1.438,1.438,0,0,0,.412-1.009A1.423,1.423,0,0,0,37.26,6.885Z",
    transform: "translate(-14.058 -1.178)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858302",
    "data-name": "Path 858302",
    d: "M0,0H24.7V24.7H0Z",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858303",
    "data-name": "Path 858303",
    d: "M0,0H24.7V24.7H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAlert);
export default __webpack_public_path__ + "static/media/EditAlert.6b7bc248cb2e6809eb67b8e0cd9d278b.svg";
export { ForwardRef as ReactComponent };